window.emoji.img_path = "/static/emoji/";
window.emoji.img_suffix = '?v=16.0';
window.emoji.include_title = true;
window.emoji.allow_native = true;
window.emoji.use_sheet = true;
window.emoji.colon_aliases = {
    '1f44d': ['like', 'thumbs_up'],
    '1f44e': ['dislike', 'thumbs_down'],
    '1f415': ['doge'],
    '1f346': ['aubergine'],
    '1f4a8': ['gust_of_wind'],
    '1f389': ['party_popper'],
    '1f631': ['shock'],
    '269b-fe0f': ['atom'],
    '2764-fe0f': ['<3', '&lt;3'],
    '1f494': ['</3', '&lt;&#x2f;3'],
    '1f642': ['simple_smile', ':)', ':-)', ')', '-)'],
    '1f603': ['=D'],
    '1f600': [':D', 'D'],
    '1f61e': [':(', '('],
    '1f622': [":'(", "'(", ':&#x27;(', '&#x27;('],
    '1f62d': [':_(', '_(','loudly_crying_face','sad_tears','bawl'],
    '1f609': [';)'],
    '1f61c': [';p'],
    '1f606': ['XD'],
    '1f604': ['^_^'],
    '1f605': ['^_^;'],
    '1f923': ['rofl'],
    '1f610': [':|', '|'],
    '1f623': ['>.<'],
    '1f6f8': ['ufo'],
    '1f9d9-200d-2640-fe0f': ['female_wizard'],
    '1f9d9-200d-2642-fe0f': ['male_wizard'],
    '1f995': ['brontosaurus', 'diplodocus'],
    '1f996': ['tyrannosaurus'],
    '1f969': ['steak'],
    '1f96b': ['soup_tin'],
    '1f9e2': ['baseball_cap'],
    '1f9d8-200d-2640-fe0f': ['female_yoga'],
    '1f9d8-200d-2642-fe0f': ['male_yoga'],
    '1f9d6-200d-2640-fe0f': ['female_sauna'],
    '1f9d6-200d-2642-fe0f': ['male_sauna'],
    '1f9d5': ['hijab'],
    '1f41e': ['ladybird','ladybug','ladybeetle','coccinellid'],
    '1f48e': ['diamond'],
    '1f607': ['angel_face'],
    '1f608': ['smiling_devil'],
    '1f47f': ['frowning_devil'],
    '1f621': ['mad_rage', 'angry_rage'],
    '1f620': ['mad'],
    '1f682': ['steam_train'],
    '1f393': ['graduation_cap'],
    '1f4a1': ['lightbulb'],
    '1f60e': ['cool_dude', 'deal_with_it'],
    '1f925': ['liar'],
    '1f430': ['bunny'],
    '1f407': ['bunny2'],
    '1f6ac': ['cigarette', 'fag'],
    '1f30a': ['water_wave'],
    '1f92a': ['crazy_face'],
    '1f92b': ['sh'],
    '1f92c': ['angry_swearing','mad_swearing','cursing','swearing','pissed_off','fuck'],
    '1f92d': ['oops'],
    '1f92e': ['throwing_up', 'being_sick'],
    '1f92f': ['mind_blown'],
    '26a1': ['lightning_bolt'],
    '1f38a': ['confetti'],
    '1f5d1-fe0f': ['rubbish', 'trash', 'garbage', 'bin', 'wastepaper_basket']

};
window.emoji.non_native = {};
var tsoffet = new Date().getTimezoneOffset();
var earth_emoji;
if (tsoffet > 180) {
    // UTC-3 or less, america
    earth_emoji = '1f30e';
} else if (tsoffet < -300) {
    // UTC+5 or more, asia
    earth_emoji = '1f30f';
} else {
    // UTC-3 - UTC+5, africa
    earth_emoji = '1f30d';
}
window.emoji.colon_aliases[earth_emoji] = ['earth'];
window.emoji.init_colons();
window.emoji.init_unified();
window.emoji.init_env();



//////////////////
// WEBPACK FOOTER
// ./app/src/lib/emojiconf.js
// module id = PT53
// module chunks = 1